var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:[
  'custom-checkbox',
  _vm.focused && 'is-focused',
  _vm.checked && 'is-checked',
]},[_c('input',{staticClass:"input",attrs:{"type":"checkbox","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"change":_vm.onChange}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }